import { initialTime, setTime } from 'utils/timeAndDate';

const DAY_VALUE_TO_NAME = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  0: 'Sunday',
};

const DAY_NAME_TO_VALUE = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 0,
};

const DAY_NAMES_IN_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function parseTimeValue(value) {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  if (typeof value !== 'string') {
    return initialTime;
  }

  const match = value.match(/^(\d{2}):(\d{2})(?::\d{2})?$/); //01:00 or 01:00:00
  if (!match) {
    return initialTime;
  }

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  return setTime(hours, minutes);
}
function formatTimeValue(value) {
  if (!value) return '';

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}`;
  }

  if (typeof value === 'string') {
    const directMatch = value.match(/^(\d{2}):(\d{2})$/);
    if (directMatch) {
      return `${directMatch[1]}:${directMatch[2]}`;
    }

    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return `${String(parsed.getHours()).padStart(2, '0')}:${String(parsed.getMinutes()).padStart(2, '0')}`;
    }
  }

  return '';
}

export function mapSchedulesToTimeProfiles(schedules) {
  const groupedByInterval = {};

  DAY_NAMES_IN_ORDER.forEach((dayName) => {
    const daySchedule = schedules && schedules[dayName];

    if (!daySchedule || !daySchedule.Enabled) {
      return;
    }

    (daySchedule.Intervals || []).forEach((interval) => {
      const from = interval && interval.From;
      const to = interval && interval.To;
      if (!from || !to) return;

      const key = `${from}-${to}`;
      if (!groupedByInterval[key]) {
        groupedByInterval[key] = {
          startTime: parseTimeValue(from),
          endTime: parseTimeValue(to),
          days: [],
        };
      }

      const dayValue = DAY_NAME_TO_VALUE[dayName];
      if (!groupedByInterval[key].days.includes(dayValue)) {
        groupedByInterval[key].days.push(dayValue);
      }
    });
  });

  return Object.values(groupedByInterval);
}
export function mapTimeProfilesToSchedules(timeProfiles) {
  const schedules = {};

  (timeProfiles || []).forEach((profile) => {
    const from = formatTimeValue(profile && profile.startTime);
    const to = formatTimeValue(profile && profile.endTime);

    if (!from || !to) {
      return;
    }

    (profile && profile.days ? profile.days : []).forEach((dayValue) => {
      const dayName = DAY_VALUE_TO_NAME[dayValue];
      if (!dayName) return;

      schedules[dayName] = { From: from, To: to };
    });
  });

  return schedules;
}
